import { z } from "zod";
import { OAuthProviderSchema } from "./oauth-providers";

export const ExternalOAuthRequest = z.object({
  id: z.string(),
  provider: OAuthProviderSchema,
  userId: z.string(),
  state: z.string(),
  createdAt: z.coerce.date(),
});

export type ExternalOAuthRequest = z.infer<typeof ExternalOAuthRequest>;
